var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-service"},[_c('moduleTitle',{attrs:{"type":"dw","title":"农业主体"}}),_c('div',{staticClass:"dry-service-echart"},[_c('myCharts',{attrs:{"pdata":_vm.listData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }